<template>
  <Modal
    title=" "
    data-testid="delete-portfolio-modal"
    size="md"
    :is-open="isOpen"
    @close="emit('close')"
  >
    <Heading :level="3" class="deletePortfolio__title">{{ title }}</Heading>
    <BaseText
      class="deletePortfolio__description"
      size="md"
      :color="NebraskaColors.elementPrimary"
    >
      {{ description }}
    </BaseText>
    <template #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            :label="buttonPrimaryLabel"
            data-testid="delete-button"
            @click="buttonPrimaryClick"
          />
        </template>
        <template v-if="isAllowedToDeletePortfolio" #button-secondary>
          <ButtonSecondary
            label="Cancelar"
            data-testid="close-button"
            @click="emit('close')"
          />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import {
  Modal,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  Heading,
  BaseText
} from '@warrenbrasil/nebraska-web';
import { remove } from '@/modules/wealth/services/portfolio';
import { useRouter } from 'vue-router/composables';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

const isAllowedToDeletePortfolio = ref(true);
const router = useRouter();

async function deletePortfolio() {
  try {
    await remove(props.portfolioId);
    router.push({ name: 'wealth' });
  } catch (error) {
    isAllowedToDeletePortfolio.value = false;
    console.error(error);
  }
}

const props = defineProps({
  isOpen: { type: Boolean, default: false },
  portfolioId: { type: String, required: true }
});

const emit = defineEmits(['close']);

const title = computed(() => {
  return isAllowedToDeletePortfolio.value
    ? 'Deseja excluir sua Carteira?'
    : 'Não é possível concluir esta ação no momento.';
});

const description = computed(() => {
  return isAllowedToDeletePortfolio.value
    ? 'Não será possivel reverter esta ação.'
    : 'Carteiras com saldo ou transações em processamento não podem ser excluídas.';
});

const buttonPrimaryLabel = computed(() => {
  return isAllowedToDeletePortfolio.value ? 'Excluir' : 'Fechar';
});

const buttonPrimaryClick = () => {
  isAllowedToDeletePortfolio.value === true ? deletePortfolio() : emit('close');
};
</script>
<style lang="less" scoped>
:deep(.modal-content) {
  padding: 0 @size-spacing-x600;
}
.deletePortfolio__title {
  color: @element-primary;
  margin-bottom: @size-spacing-x600;
  text-align: start;
  width: 100%;
}
.deletePortfolio__description {
  margin-bottom: @size-spacing-x1000;
  width: 100%;
  text-align: left;
}
</style>
